module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCI+CiAgPHBvbHlnb24gZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJldmVub2RkIiBwb2ludHM9IjQwMS42NTcgNTg1MS4zMTQgMzk2IDU4NDUuNjU3IDM5Ni45MTcgNTg0NC43NCA0MDEuNjU3IDU4NDkuNDc5IDQwNi4zOTYgNTg0NC43NCA0MDcuMzE0IDU4NDUuNjU3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzk2IC01ODQ0KSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/img/select.svg
// module id = 613
// module chunks = 168707334958949